module.exports = __webpack_public_path__ + "img/header-ccc_mobile@2x.53732ed.jpg";